import React from 'react';
import PropTypes from 'prop-types';
import Img from 'gatsby-image';
import Reveal from '../../reveal';
import { Spring } from 'react-spring';
import * as easings from 'd3-ease';
import ProjectBlurb from '../project-blurb';
import styles from './project-full-banner.module.css';

const ProjectFullBanner = props => {
  return (
    <Reveal>
      <ProjectFullBannerContent {...props} />
    </Reveal>
  );
};

const ProjectFullBannerContent = props => {
  const { image, blurb, wrapperPadding, isInView, hideBlurb } = props;

  const animationConfig = {
    delay: 300,
    duration: 900,
    easing: easings.easeCubicOut,
  };
  return (
    <Spring
      from={{ opacity: '0', scale: 'scale(1.15, 1.15)' }}
      to={{
        opacity: isInView ? '1' : '0',
        scale: isInView ? 'scale(1, 1)' : 'scale(1.15, 1.15)',
      }}
      config={animationConfig}
    >
      {animation => (
        <div
          className={styles.wrapper}
          style={{
            padding: wrapperPadding,
            opacity: animation.opacity,
            transform: animation.scale,
          }}
        >
          <Img
            className={styles.image}
            sizes={image.localFile.childImageSharp.sizes}
            backgroundColor={true}
          />
          {hideBlurb !== true && <ProjectBlurb blurb={blurb} />}
        </div>
      )}
    </Spring>
  );
};

ProjectFullBannerContent.propTypes = {
  wrapperPadding: PropTypes.string,
  isInView: PropTypes.bool,
  image: PropTypes.object,
  blurb: PropTypes.string,
};

export default ProjectFullBanner;



// WEBPACK FOOTER //
// ./src/components/project/project-full-banner/index.js